import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";



import { BODiagnosticNovo } from "../models/BODiagnosticNovo.model";
import { BOTranspDiagnosticNovo } from "../models/auxiliars/BOTranspDiagnosticNovo.model";
import { BOClinicHistoryObservations } from '../models/BOClinicHistoryObservations.model';

@Injectable({
  providedIn: 'root'
}

)
export class ClinicHistoryObservationsService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ClinicHistoryObservations/';

    constructor(private http:HttpClient){}

//#region First

    // getAllByPatientId(patientId:number):Observable<BOClinicHistoryObservations[]>{
    //     return this.http.get<BOClinicHistoryObservations[]>(this.myAppUrl + this.myApiUrl+'getAllByPatientId/'+patientId);
    // }

    getAllByClinicHistoryId(clinicHistoryId:number):Observable<BOClinicHistoryObservations[]>{
        return this.http.get<BOClinicHistoryObservations[]>(this.myAppUrl + this.myApiUrl+'getAllByClinicHistoryId/'+clinicHistoryId);
    }

//#endregion First
//#region Single
  createOrUpdateClinicHistoryObservationsSingle(patientId:number,
                                                clinicHistoryId:number,
                                                chObservations:BOClinicHistoryObservations):Observable<BOClinicHistoryObservations>
  {
    console.log("EN EL SERVICE COUCHOBSERVATIONSINGLE, chObservations es:", chObservations)
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(chObservations);
      return this.http.post<BOClinicHistoryObservations>(this.myAppUrl + this.myApiUrl + 'createOrUpdateClinicHistoryObservationsSingle/' + patientId + '/' + clinicHistoryId,body,httpOptions);
  }

deleteClinicHistoryObservationsSingle(id:number):Observable<BOClinicHistoryObservations>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOClinicHistoryObservations>(this.myAppUrl + this.myApiUrl + 'deleteClinicHistoryObservationsSingle/' + id,null,httpOptions);
    }


//#endregion Single


}
